import {
  MarketAccessory,
  MarketList,
  MarketRow,
} from '@market/react';
import type { ComponentType, JSX } from 'react';
import {
  type MarketIconProps,
  MarketArrowRotateCounterclockwiseIcon,
  MarketBellIcon,
  MarketCalendarIcon,
  MarketCheckmarkIcon,
  MarketEnvelopeIcon,
  MarketEyeIcon,
  MarketFileUploadIcon,
  MarketFilterIcon,
  MarketGearIcon,
  MarketHomeIcon,
  MarketHumanIcon,
  MarketLocationPinIcon,
  MarketLockOnIcon,
  MarketMagnifyingGlassIcon,
  MarketMinusIcon,
  MarketPencilWritingIcon,
  MarketPhoneIcon,
  MarketPlusIcon,
  MarketPrintIcon,
  MarketQuestionMarkCircleIcon,
  MarketStarIcon,
  MarketTrashcanIcon,
  MarketXIcon,
} from '@squareup/market-react/icons';
import type { ListProps } from '../components/page/product-page-header/ProductPageHeader';

// Icon lookup map for dynamic icon names
const ICON_MAP: Record<string, ComponentType<MarketIconProps>> = {
  bell: MarketBellIcon,
  calendar: MarketCalendarIcon,
  checkmark: MarketCheckmarkIcon,
  cog: MarketGearIcon,
  gear: MarketGearIcon,
  edit: MarketPencilWritingIcon,
  pencil: MarketPencilWritingIcon,
  envelope: MarketEnvelopeIcon,
  eye: MarketEyeIcon,
  'file-upload': MarketFileUploadIcon,
  filter: MarketFilterIcon,
  help: MarketQuestionMarkCircleIcon,
  home: MarketHomeIcon,
  location: MarketLocationPinIcon,
  lock: MarketLockOnIcon,
  minus: MarketMinusIcon,
  person: MarketHumanIcon,
  human: MarketHumanIcon,
  phone: MarketPhoneIcon,
  plus: MarketPlusIcon,
  print: MarketPrintIcon,
  refresh: MarketArrowRotateCounterclockwiseIcon,
  search: MarketMagnifyingGlassIcon,
  star: MarketStarIcon,
  trash: MarketTrashcanIcon,
  x: MarketXIcon,
};

export const buildMarketList = (list: ListProps | JSX.Element) => {
  if (list && typeof list === 'object' && 'options' in list) {
    const { className, slot, options } = list;
    return (<MarketList className={className} slot={slot || 'content'}>
      {options.map((options) => {
        const {
          key, icon, onClick, label,
        } = options;
        return (
          <MarketRow key={key || label} onClick={onClick}>
            {icon && ICON_MAP[icon] &&
              <MarketAccessory slot="leading-accessory" size="icon">
                {(() => {
                  const IconComponent = ICON_MAP[icon];
                  return <IconComponent aria-hidden />;
                })()}
              </MarketAccessory>
            }
            <label>{label}</label>
          </MarketRow>);
      })}
    </MarketList>);
  }

  return list;
};
